import { render } from "./modal-list.vue?vue&type=template&id=19ab8c78"
import script from "./modal-list.vue?vue&type=script&lang=js"
export * from "./modal-list.vue?vue&type=script&lang=js"

import "./modal-list.vue?vue&type=style&index=0&id=19ab8c78&lang=scss"

import exportComponent from "/home/gebruiker/www/fresh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__